module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('Heading', {
    attrs: {
      "isLogin": _vm.isLogin
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "hotlist-wrap",
    attrs: {
      "id": "hotlist"
    }
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("新能源汽车推荐车型目录")]), _vm._v(" "), _c('div', {
    staticClass: "filter-wrapper container"
  }, [_c('div', {
    staticClass: "grid-4"
  }, [_c('p', {
    staticClass: "filter-title"
  }, [_vm._v("企业名(可多选)")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.entOptions
    },
    on: {
      "selected": _vm.entSelected
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grid-4"
  }, [_c('p', {
    staticClass: "filter-title"
  }, [_vm._v("品牌")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.brand),
      expression: "filter.brand"
    }],
    attrs: {
      "name": "",
      "disabled": _vm.brandDisabled
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "brand", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.brands), function(brand) {
    return _c('option', {
      domProps: {
        "value": brand
      }
    }, [_vm._v(_vm._s(brand))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "grid-4"
  }, [_c('p', {
    staticClass: "filter-title"
  }, [_vm._v("新能源车类型（可多选）")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.carTypeOptions
    },
    on: {
      "selected": _vm.carTypeSelected
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grid-4"
  }, [_c('p', {
    staticClass: "filter-title"
  }, [_vm._v("电池系统供应商")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.battery_system),
      expression: "filter.battery_system"
    }],
    attrs: {
      "name": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "battery_system", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.batterys), function(battery) {
    return _c('option', {
      domProps: {
        "value": battery
      }
    }, [_vm._v(_vm._s(battery))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "grid-4"
  }, [_c('p', {
    staticClass: "filter-title"
  }, [_vm._v("电驱动系统供应商")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.electric_drive),
      expression: "filter.electric_drive"
    }],
    attrs: {
      "name": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "electric_drive", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.drives), function(drive) {
    return _c('option', {
      domProps: {
        "value": drive
      }
    }, [_vm._v(_vm._s(drive))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "grid-4"
  }, [_c('p', {
    staticClass: "filter-title"
  }, [_vm._v("超级电容供应商")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.ultracapacitor),
      expression: "filter.ultracapacitor"
    }],
    attrs: {
      "name": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "ultracapacitor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.ultracapacitors), function(ultracapacitor) {
    return _c('option', {
      domProps: {
        "value": ultracapacitor
      }
    }, [_vm._v(_vm._s(ultracapacitor))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "grid-4"
  }, [_c('p', {
    staticClass: "filter-title"
  }, [_vm._v("发动机供应商")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.engine),
      expression: "filter.engine"
    }],
    attrs: {
      "name": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "engine", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.engines), function(engine) {
    return _c('option', {
      domProps: {
        "value": engine
      }
    }, [_vm._v(_vm._s(engine))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "grid-4"
  }, [_c('p', {
    staticClass: "filter-title"
  }, [_vm._v("是否免税")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.is_free_tax),
      expression: "filter.is_free_tax"
    }],
    attrs: {
      "name": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "is_free_tax", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("否")])])]), _vm._v(" "), _c('div', {
    staticClass: "grid-4"
  }, [_c('p', {
    staticClass: "filter-title"
  }, [_vm._v("是否补贴")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.is_subsidy),
      expression: "filter.is_subsidy"
    }],
    attrs: {
      "name": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "is_subsidy", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("否")])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-wrapper"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.resetFilter()
      }
    }
  }, [_vm._v("还原默认")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-blue",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("筛选")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searched),
      expression: "searched"
    }],
    staticClass: "filter-result"
  }, [_c('div', {
    staticClass: "filter-result-title container"
  }, [_c('h3', [_vm._v("筛选后 共 " + _vm._s(_vm.list.total) + " 条结果")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.download()
      }
    }
  }, [_vm._v("下载筛选结果")])]), _vm._v(" "), _vm._l((_vm.list.data), function(item, index) {
    return _c('div', {
      staticClass: "filter-result-item"
    }, [_c('div', {
      staticClass: "result-block container"
    }, [_c('div', {
      staticClass: "grid-4"
    }, [_c('p', {
      staticClass: "notification-number"
    }, [_vm._v("\n                                " + _vm._s(item.notice_num) + "\n                                "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.is_free_tax === '1'),
        expression: "item.is_free_tax === '1'"
      }],
      staticClass: "free-icon"
    }, [_vm._v("免")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.is_subsidy === '1'),
        expression: "item.is_subsidy === '1'"
      }],
      staticClass: "subsidy-icon"
    }, [_vm._v("补")])]), _vm._v(" "), _c('p', {
      staticClass: "company-name"
    }, [_vm._v(_vm._s(item.enterprise_name))])]), _vm._v(" "), _c('div', {
      staticClass: "grid-4"
    }, [_c('p', {
      staticClass: "brand-name"
    }, [_vm._v("\n                                " + _vm._s(item.brand) + "\n                                "), _c('span', {
      staticClass: "car-type"
    }, [_vm._v(_vm._s(item.car_type))])]), _vm._v(" "), _c('p', {
      staticClass: "dir-order"
    }, [_vm._v(_vm._s(item.duty_batch))])]), _vm._v(" "), _c('div', {
      staticClass: "grid-4"
    }, [_c('a', {
      staticClass: "dropdown-anchor",
      attrs: {
        "href": "javascript:;",
        "id": 'list-' + index
      },
      on: {
        "click": function($event) {
          _vm.showDetail($event)
        }
      }
    }, [_vm._v("详情")])])]), _vm._v(" "), _c('div', {
      staticClass: "result-block result-dropdown-content container",
      attrs: {
        "id": 'block-' + index
      }
    }, [_c('div', {
      staticClass: "container"
    }, [_c('div', {
      staticClass: "grid-4"
    }, [_c('p', {
      staticClass: "notification-number"
    }, [_vm._v("\n                                    " + _vm._s(item.notice_num) + "\n                                    "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.is_free_tax === '1'),
        expression: "item.is_free_tax === '1'"
      }],
      staticClass: "free-icon"
    }, [_vm._v("免")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.is_subsidy === '1'),
        expression: "item.is_subsidy === '1'"
      }],
      staticClass: "subsidy-icon"
    }, [_vm._v("补")])]), _vm._v(" "), _c('p', {
      staticClass: "company-name"
    }, [_vm._v(_vm._s(item.enterprise_name))])]), _vm._v(" "), _c('div', {
      staticClass: "grid-4"
    }, [_c('p', {
      staticClass: "brand-name"
    }, [_vm._v("\n                                    " + _vm._s(item.brand) + "\n                                    "), _c('span', {
      staticClass: "car-type"
    }, [_vm._v(_vm._s(item.car_type))])]), _vm._v(" "), _c('p', {
      staticClass: "dir-order"
    }, [_vm._v(_vm._s(item.duty_batch))])]), _vm._v(" "), _c('div', {
      staticClass: "grid-4"
    })]), _vm._v(" "), _c('div', {
      staticClass: "supplier-detail container"
    }, [_c('div', {
      staticClass: "make-distance container"
    }, [_c('div', {
      staticClass: "grid-4"
    }, [_c('p', {
      staticClass: "grey-text"
    }, [_vm._v("配置ID")]), _vm._v(" "), _c('p', [_vm._v("\n                                        " + _vm._s(item.configure_id) + "\n                                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "grid-4"
    }, [_c('p', {
      staticClass: "grey-text"
    }, [_vm._v("电池系统供应商")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.battery_system))])]), _vm._v(" "), _c('div', {
      staticClass: "grid-4"
    }, [_c('p', {
      staticClass: "grey-text"
    }, [_vm._v("电驱动系统供应商")]), _vm._v(" "), _c('p', [_vm._v("\n                                        " + _vm._s(item.electric_drive) + "\n                                    ")])])]), _vm._v(" "), _c('div', {
      staticClass: "grid-4"
    }, [_c('p', {
      staticClass: "grey-text"
    }, [_vm._v("\n                                    超级电容供应商\n                                ")]), _vm._v(" "), _c('p', [_vm._v("\n                                    " + _vm._s(item.ultracapacitor) + "\n                                ")])]), _vm._v(" "), _c('div', {
      staticClass: "grid-4"
    }, [_c('p', {
      staticClass: "grey-text"
    }, [_vm._v("发动机供应商")]), _vm._v(" "), _c('p', [_vm._v("\n                                    " + _vm._s(item.engine) + "\n                                ")])])]), _vm._v(" "), _c('div', {
      staticClass: "performance-detail container"
    }, [_c('div', {
      staticClass: "make-distance container"
    }, [_c('div', {
      staticClass: "grid-4"
    }, [_c('p', {
      staticClass: "grey-text"
    }, [_vm._v("\n                                        纯电续驶里程（km）\n                                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                                        " + _vm._s(item.ev_mileage) + "\n                                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "grid-4"
    }, [_c('p', {
      staticClass: "grey-text"
    }, [_vm._v("\n                                        发动机排量（mL）\n                                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                                        " + _vm._s(item.engine_output) + "\n                                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "grid-4"
    }, [_c('p', {
      staticClass: "grey-text"
    }, [_vm._v("整车整备质量（kg）")]), _vm._v(" "), _c('p', [_vm._v("\n                                        " + _vm._s(item.quality) + "\n                                    ")])])]), _vm._v(" "), _c('div', {
      staticClass: "grid-4"
    }, [_c('p', {
      staticClass: "grey-text"
    }, [_vm._v("\n                                    动力蓄电池组总能量（kWh）\n                                ")]), _vm._v(" "), _c('p', [_vm._v("\n                                    " + _vm._s(item.battery_power) + "\n                                ")])]), _vm._v(" "), _c('div', {
      staticClass: "grid-4"
    }, [_c('p', {
      staticClass: "grey-text"
    }, [_vm._v("\n                                    燃料消耗量（L/100km）\n                                ")]), _vm._v(" "), _c('p', [_vm._v("\n                                    " + _vm._s(item.fuel_wastage) + "\n                                ")])]), _vm._v(" "), _c('div', {
      staticClass: "grid-4"
    }, [_c('p', {
      staticClass: "grey-text"
    }, [_vm._v("\n                                    动力蓄电池组总质量（kg）\n                                ")]), _vm._v(" "), _c('p', [_vm._v("\n                                    " + _vm._s(item.battery_quality) + "\n                                ")])])])])])
  }), _vm._v(" "), _c('p', {
    staticClass: "list-footer"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.list.to),
      expression: "list.to"
    }],
    staticClass: "btn btn-blue",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.more()
      }
    }
  }, [_vm._v("更多")])])], 2)])]), _vm._v(" "), _c('Side', {
    attrs: {
      "ad": _vm.ad
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8b3752d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hotlist.vue
// module id = 574
// module chunks = 1